import { CheckBoxWidget } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { ExplorerStyles } from '../../../components/Explorer/ExplorerStyles';

export interface ICheckboxCellOptions {
  onCheckboxClicked: (row: DataGrid.Row) => void;
  checkboxCellTestIdFn: (row: DataGrid.Row) => string;
  isRowSelected: (row: DataGrid.Row) => boolean | 'mixed';
  isRowDisabled: (row: DataGrid.Row) => boolean;
  labelledById?: (row: DataGrid.Row) => string;
}

export function CheckboxCell(options: ICheckboxCellOptions): React.Factory<BodyCell.Props> {
  return (props: BodyCell.Props) => <CheckboxCellRenderer options={options} row={props.row} />;
}

// Module-scoped — stable identity prevents unmount/remount when columns rebuild.
function CheckboxCellRenderer({ options, row }: { options: ICheckboxCellOptions, row: DataGrid.Row }) {
  const handleClick: React.MouseEventHandler = event => {
    options.onCheckboxClicked(row);
    event.stopPropagation();
  };

  const labelledById = options.labelledById?.(row);
  const checked = options.isRowSelected(row);

  return (
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    <span
      onClick={handleClick}
      className={options.isRowDisabled(row) ? ExplorerStyles.CheckboxCellContainerDisabled : ExplorerStyles.CheckboxCellContainer}
      title={Messages.listViewCheckbox()}
    >
      <CheckBoxWidget
        testId={options.checkboxCellTestIdFn(row)}
        checked={!!checked}
        indeterminate={checked === 'mixed' ? true : undefined}
        tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
        aria-label={labelledById ? null : Messages.listViewCheckbox()}
        aria-labelledby={labelledById}
        removeLeftMargin={true}
      />
    </span>
  );
}
